/***
* Add by jfzhu
* created:20190805
* 注:商家联盟拓客首页
*/
<template>
  <div v-if="!activityDataStatus">
    <img :src="logo">
  </div>
  <div v-else class="union-item-div">
    <t-p-follow ref="follow" :open-type="0" :subscribe="subscribe" :biz="biz"/>
    <div class="union-item"
         :style="{backgroundImage:'url(' + imageUrl+activityData.content + ')',backgroundSize:'100%',backgroundSize:'100%'}">
      <div class="content-top-div">
        <img :src="imageUrl+activityData.contentTop"/>
      </div>
      <div class="title-div">
        INTERESTED
        <br/>他们很感兴趣
      </div>
      <div class="tragedy">
        <div class="userinfo">
          <img class="avatar-img" :src="userinfo.headimgurl"/>
          <div class="info">
            <div class="info-top">
              <div class="name">{{ userinfo.nickname }}</div>
              <div class="diamond">
                <img v-for="item in diamondsImg" :src="item"/>
              </div>
            </div>
            <div class="text" v-if="diamondsImg.length > 0">分享一次，点亮一个钻，有几率获得99999大红包。</div>
          </div>
        </div>
        <div class="morals">
          <span>共有</span>
          <span class="morals-value-1">{{ userNum }}</span>
          <span>人看了</span>
        </div>
        <div class="morals">
          <span>总订单人数</span>
          <span class="morals-value-2">{{ orderNum }}</span>
          <span>人</span>
        </div>
        <div class="user-list">
          <template v-for="item in orderUser">
            <img :src="item.avatar"/>
          </template>
        </div>
      </div>
      <div class="title-div">
        COUNT DOWN
        <br/>活动倒计时
      </div>
      <div class="progress">
        <template v-if="activityTime == 0">
          <div class="prs-text">
            活动倒计时
            <span>{{ day }}</span>天
            <span>{{ hour }}</span>时
            <span>{{ minute }}</span>分
            <span>{{ second }}</span>秒
          </div>
          <div class="schedule-div">
            <div class="container">
              <div class="skills html" :style="{width:schedule}"></div>
            </div>
          </div>
          <div class="bottom-text">
            <span>活动限额<span class="text-color">{{ activityData.limitNumber }}</span>人</span>
            <span>已购<span class="text-color">{{ orderNum }}</span>人</span>
            <span>进度<span class="text-color">{{ schedule }}</span></span>
          </div>
        </template>
        <div class="prs-text" v-if="activityTime == 1">
          <span style="font-size: 20px">活动已经结束</span>
        </div>
        <div class="prs-text" v-if="activityTime == 2">
          <span style="font-size: 20px">活动未开始</span>
        </div>
      </div>
      <template v-if="activityData.redPaperType == 1 && redEnvelope.length > 0">
        <div class="title-div">
          RED PACK TO BE RECEIVED
          <br/>待领取红包
        </div>
        <div class="red-envelope-div">
          <div class="content">
            <div class="red-envelope-list" v-for="item in redEnvelope">
              <div class="span-div">
                {{ item.spreadName }}
                <span>{{ item.typeName }}，获得{{ item.totolMoney }}</span>元
                <span>红包</span>
              </div>
              <div class="get-btn" @click="getRedEnvelope(item.id,item.totolMoney)">领取</div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="orderList.length > 0">
        <div class="title-div">
          PURCHASE LIST
          <br/>最新购买列表TOP20
        </div>
        <div class="order-div">
          <div class="order-info" v-for="item in orderList">
            <img :src="item.avatar"/>
            <span>{{ item.nickname }}</span>
            <span style="color:#CCCCCC">付款成功</span>
          </div>
        </div>
      </template>
      <div class="title-div">
        ACTIVaITY
        <br/>活动介绍
      </div>
      <div class="store-list-div">
        <div class="store-item" v-for="(item,index) in storeList" :key="index">
          <span class="store-name">{{ index + 1 }}.{{ item.name }}</span>
          <div class="store-address" @click="goMap(item)">
            <img src="../../resource/img/地址@2x.png"/>
            <span>{{ item.address }}</span>
          </div>
          <div class="store-bottom-info">
            <div class="store-phone" @click="cell(item.phone)">
              <img src="../../resource/img/电话@2x.png"/>
              <span>{{ item.phone }}</span>
            </div>
            <div class="navigation" @click="goMap(item)">
              <img src="../../resource/img/导航@2x.png"/>
              导航
            </div>
          </div>
          <img class="store-img" :src="imageUrl+item.picInfo">
          <div class="store-bottom-text" @click="openStoreDetail(item)">点击查看详情</div>
        </div>
        <div class="rule-div">
          <div class="title-text">活动规则</div>
          <div class="textarea">
            {{ activityData.ruleInfo }}
          </div>
        </div>
      </div>
      <div class="title-div">
        EARNING LIST
        <br/>“赚”排行榜TOP20
      </div>
      <div class="ranking-div">
        <marquee behavior="scroll" contenteditable="true" scrollamount="4" direction="up"
                 style="height: 350px;" v-if="redPackList.length > 4 ">
          <div class="ranking-item" v-for="(item,index) in redPackList" :key="index">
            <span class="index-span">{{ index + 1 }}.</span>
            <img class="user-avatar" :src="item.avatar">
            <div class="user-info">
              <span class="name">{{ item.nickName }}</span>
              <span style="color: #999999;">推广{{ item.spreadCount }}人</span>
            </div>
            <div class="award-info">
              <span style="color: #999999;">获得奖金：</span>
              <span style="color: #D00000;">{{ item.totolMoney }}</span>
            </div>
          </div>
        </marquee>
        <div class="ranking-item" v-for="(item,index) in redPackList" :key="index" v-if="redPackList.length <= 4 ">
          <span class="index-span">{{ index + 1 }}.</span>
          <img class="user-avatar" :src="item.avatar">
          <div class="user-info">
            <span class="name">{{ item.nickName }}</span>
            <span style="color: #999999;">推广{{ item.spreadCount }}人</span>
          </div>
          <div class="award-info">
            <span style="color: #999999;">获得奖金：</span>
            <span style="color: #D00000;">{{ item.totolMoney }}</span>
          </div>
        </div>
      </div>
      <div class="content-bottom-div">
        <img :src="imageUrl+activityData.contentBottom"/>
      </div>
      <div class="bottom-code-info" v-if="!this.$util.isArrOrNull(activityData.contactImg)">
        <span class="title">活动真实有效</span>
        <span class="title-text">请您放心购买 绝无硬性消费</span>
        <div class="code-img-div">
          <img class="code-img-border" src="../../resource/img/as11.png"/>
          <img class="code-img" :src="imageUrl+activityData.contactImg"/>
        </div>
        <span class="bottom-code-text">长按识别二维码，关注公众号</span>
        <span class="bottom-code-text-two">及时获取红包通知和活动消息</span>
      </div>
      <div style="height:75px;"></div>
      <div class="fixed-bottom-menu">
        <div class="menu-div share-menu" @click="draw()">分享赚红包</div>
        <div class="menu-div buy-menu" v-if="!showOrder" @click="buy()">立即购买</div>
        <div class="menu-div buy-menu" v-else @click="openOrder()">查看订单</div>
      </div>
      <div class="fixed-menu top-menu">
        <div @click="playMusic">
          <audio autoplay loop preload ref="musicPlay" :src="activityData.backgroundMusic" id="music"></audio>
          <img class="music-img" ref="musicInfo" src="../../resource/img/yinyue.png"/>
        </div>
      </div>
      <div class="fixed-menu bottom-menu">
        <div @click="openWithdraw()">
          <img src="../../resource/img/提现@2x.png"/>
        </div>
        <!--        <div @click="toUserinfo()">-->
        <!--          <img src="../../resource/img/icon_mine.png"/>-->
        <!--        </div>-->
        <!-- <div @click="toUserinfo()">
           <img src="../../resource/img/kefu.png" />
         </div>-->
        <div @click="goTop()">
          <img src="../../resource/img/顶部@2x.png"/>
        </div>
      </div>
    </div>
    <!-- 购买界面遮罩层开始-->
    <div class="mask buy" v-show="showBuy">
      <div class="buy-div">
        <div class="buy-item">
          <div class="title">姓名</div>
          <input type="text" placeholder="请输入姓名" v-model="formObj.truename"/>
        </div>
        <div class="buy-item">
          <div class="title">联系电话</div>
          <input type="text" placeholder="请输入手机号" v-model="formObj.phone"/>
        </div>
        <div class="buy-item">
          <div class="title">备注</div>
          <textarea rows="4" cols="4" placeholder="请输入备注信息" v-model="formObj.remark"/>
        </div>
        <button type="button" class="buy-btn" @click="saveOrder()">提交</button>
      </div>
      <img class="close-img" src="../../resource/img/pop_icon_close.png" @click="closeBuy"/>
    </div>
    <!-- 手机验证遮罩层结束-->
    <!--分享海报 start-->
    <div class="mask poster" v-show="showPoster">
      <div v-if="posterImg == ''" ref="box" class="poster-box">
        <img :src="sharePic" class="top-img"/>
        <div class="user">
          <img class="logo-img" :src="userinfo.headimgurl"/>
          <div class="span-info">
            <span class="user-name">{{ userinfo.nickname }}</span>
            <span class="text-span">邀请你参加</span>
          </div>
        </div>
        <div class="share-title">{{ activityData.shareTitle }}</div>
        <div class="bottom-div">
          <div id="qrcode"></div>
          <div class="discern-div">
            <img class="discern-img" src="../../resource/img/active/icon_discern.png">
            <span class="span-text">长按识别二维进入活动</span>
          </div>
        </div>
      </div>
      <div class="posterImg">
        <span class="title-hint" style="">长按图片保存到相册</span>
        <img :src="posterImg" alt/>
        <img src="../../resource/img/pop_icon_close.png" @click="closePoster"
             style="width: 30px;height: 30px;margin-top: 25px;"/>
      </div>
    </div>
    <!--分享海报 end -->
    <!-- 手机验证遮罩层开始-->
    <div class="yz_page" v-show="TCyzm">
      <div class="yzdiv">
        <p
          style="font-family:PingFangSC-Regular;font-weight:400;color:rgba(85,85,85,1);margin-left:3vw;font-size: 0.5rem">
          绑定手机号</p>
        <input type="text" placeholder="请输入手机号码" class="yzminput" ref="phone"/>
        <img src="../../resource/img/querenbangding.png" alt style="width:40%;height:18%;margin-left:30%;margin-top: 5%"
             @click="bindPhone"/>
      </div>
      <div class="close_btn">
        <img src="../../resource/img/pop_icon_close.png" @click="closeBindPhone"
             style="width: 30px;height: 30px;margin-top: 15px;"/>
      </div>
    </div>
    <!-- 手机验证遮罩层结束-->
    <div class="Ewm_page" v-show="pdUid">
      <div class="imgewm" @click="closePdUidMask()">暂无余额</div>
    </div>
    <div class="form-content">
      <div class="titleInfo" :style="{display:isEnd ? 'block' : 'none'}">
        <div class="title">
          <span style="font-size: 5vw; margin: 5% 5%;">温馨提醒</span>
        </div>
        <div style="width: 100%; margin: 10% 20%" v-if="activityTime == 1">
          <span style="font-size: 5vw;">该活动已经结束,感谢参与</span>
        </div>
        <div style="width: 100%; margin: 10% 18%" v-if="activityTime == 2">
          <span style="font-size: 5vw;">该活动未开始,期待你的参与</span>
        </div>
        <div style="width: 100%; margin: 10% 18%" v-if="activityTime == 3">
          <span style="font-size: 5vw;">该活动已经结束,感谢参与</span>
        </div>
      </div>
    </div>
    <div class="mask" :style="{display:isMask ? 'block' : 'none'}"
         @click="closeMask"></div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import {qrcanvas} from 'qrcanvas'
import wx from 'weixin-js-sdk'
import TPFollow from '../common/comp/TPFollow'

export default {
  name: 'MerUnionActivity',
  components: {TPFollow},
  data() {
    return {
      isOperate: true,
      urlParam: {},
      imageUrl: '',
      activityData: {},
      cutDownTime: 300,
      activityTime: 2,
      //是否关注过
      subscribe: 0,
      //关注跳转公众号
      biz: null,
      formObj: {
        activityId: null,
        merId: null,
        storeId: null,
        price: 0,
        truename: '',
        phone: '',
        buyNum: 1,
        openid: '',
        nickname: '',
        sex: '1',
        avatar: '',
        remark: '',
        fansid: null,
        sourceType: null
      },
      user: null,
      weixinUrl: this.$common.weixinUrl,
      pdUid: false,
      showPoster: false,
      showOrder: false,
      posterImg: '',
      redPackList: [],
      isAllListDh: 0,
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      isPlay: 0,
      isMask: false,
      isEnd: false,
      title: '商家联盟活动',
      showBuy: false,
      storeList: [],
      nickname: '',
      openid: '',
      timeId: null,
      limitNumber: 0,
      userNum: 0,
      orderNum: 0,
      orderUser: [],
      schedule: 0,
      orderList: [],
      sharePic: '',
      diamondsImg: [],
      redEnvelope: [],
      orderInfo: null,
      activityDataStatus: false,
      logo: require('../../resource/img/white.png'),
      wxNickname: this.$common.nickname,
      TCyzm: false
    }
  },
  created() {
    this.urlParam = this.$route.query
    this.urlParam.storeId = this.$util.isArrOrNull(this.urlParam.storeId) ? '' : this.urlParam.storeId
    if (this.urlParam.spreadOpenid == undefined) {
      this.urlParam.spreadOpenid = null
    }
    if (this.urlParam != null) {
      this.formObj.activityId = this.urlParam.activityId
      this.formObj.merId = this.urlParam.merId
      this.formObj.storeId = this.urlParam.storeId
      this.formObj.price = this.urlParam.price
      if (this.urlParam.subscribe == 1) {
        this.subscribe = 1
      }
    }
    this.$common.changetitle(this.title)
  },
  watch: {
    //监听活动限额人数变化计算进度
    limitNumber: function () {
      this.schedule = (this.orderNum / this.limitNumber).toFixed(2) * 100 + '%'
    },
    'activityData.backgroundMusic': function (val) {
      if (val != null && val != '') {
        setTimeout(() => {   //设置延迟执行
          this.$refs.musicPlay.play()
        }, 1000)
      }
    }
  },
  mounted() {
    // this.$api.getUrl().then(res => {
    //
    // }).catch(() => {
    // })
    this.imageUrl = 'https://files.mbspt.com'
    this.Wechat()
  },
  methods: {
    //微信授权
    Wechat() {
      if (!this.$route.query.userInfo) {
        this.$api.post({
          url: '/merchant/api/activity/merchant-union-market-extend/get/wxcode',
          data: {
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            merId: this.urlParam.merId,
            price: this.urlParam.price,
            spreadOpenid: this.urlParam.spreadOpenid
          },
          login: false
        }).then(res => {
          window.location.href = res.data.url + '?activityId=' + this.urlParam.activityId + '&merId=' + this.urlParam.merId
            + '&storeId=' + this.urlParam.storeId + '&price=' + this.urlParam.price + '&spreadOpenid=' + this.urlParam.spreadOpenid
        })
      } else {
        this.userinfo = JSON.parse(this.$route.query.userInfo)
        this.formObj.sourceType = this.$route.query.sourceType
        this.getData()
        this.getFansData()
        this.getDataCount()
      }
    },
    //获取活动信息
    getData() {
      this.$api.post({
        url: '/merchant/api/activity/merchant-union-market-extend/find/act-order-info',
        data: {
          activityId: this.urlParam.activityId,
          storeId: this.urlParam.storeId
        },
        login: false
      }).then(res => {
        if (res.data != null) {
          if (!this.$util.isArrOrNull(res.data.spreadList)) {
            this.process(res.data.spreadList)
          }
          //获取店铺列表
          if (!this.$util.isArrOrNull(res.data.storeList)) {
            this.storeList = res.data.storeList
          }
          //获取订单数据
          if (!this.$util.isArrOrNull(res.data.orderList)) {
            this.orderList = res.data.orderList
          }
          //活动数据处理
          if (res.data.activity != null) {
            this.activityDataStatus = true
            this.activityData = res.data.activity
            this.$common.activitydata = this.activityData
            this.limitNumber = this.activityData.limitNumber
            //倒计时：
            this.activityData.startDate = this.activityData.startDate.replace(/\-/g, '/')
            this.activityData.endDate = this.activityData.endDate.replace(/\-/g, '/')
            this.activityData.startDate = new Date(Date.parse(this.activityData.startDate))
            this.activityData.endDate = new Date(Date.parse(this.activityData.endDate))
            this.activityData.startDate = this.activityData.startDate.getTime()
            this.activityData.endDate = this.activityData.endDate.getTime()
            //转图片为base64
            this.imageUrlToBase64(this.activityData.sharePic)
            let timeId = setInterval(this.showDateTime, 1000) //执行的定时器
            this.timeId = timeId
            this.downTimeId = setInterval(this.cutDownTimeFun, 1000)//开始定时器
          }
          if (!this.$util.isArrOrNull(this.activityData.backgroundMusic)) {
            this.$set(this.activityData, 'backgroundMusic', this.imageUrl + this.activityData.backgroundMusic)
          }
          //获取
          this.addDiamonds()
          this.getConfig()
        }
      }).catch(err => {
        this.activityTime = 3
        this.isEnd = true
        this.isMask = true
      })
    },
    //获取粉丝信息
    getFansData() {
      this.$api.post({
        url: '/merchant/api/user/fans/findActivityFans',
        data: {
          merId: this.urlParam.merId,
          openid: this.userinfo.openid
        },
        login: false
      }).then(res => {
        this.user = res.data
        this.$common.userinfo = this.user
        this.formObj.fansid = this.user.id
        this.getUserOrder()
        this.getDiamondsData()
        this.getUserRed() //获取为领取红包
      })
    },
    //活动统计数据
    getDataCount() {
      this.$api.post({
        url: '/merchant/api/activity/merchant-union-market-extend/find/activity/data',
        data: {
          merId: this.urlParam.merId,
          storeId: this.urlParam.storeId,
          activityId: this.urlParam.activityId,
          activityType: 1
        },
        login: false
      }).then(res => {
        this.userNum = res.data.viewCount ? res.data.viewCount : 0
        this.orderNum = res.data.applyCount ? res.data.applyCount : 0
        this.orderUser = res.data.viewUser
        this.schedule = (this.orderNum / this.limitNumber).toFixed(2) * 100 + '%'
      })
    },
    getConfig() {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/find/share/config',
        data: {
          merId: this.urlParam.merId,
          url: encodeURIComponent(location.href.split('#')[0])
        },
        login: false
      }).then(res => {
        this.biz = res.data.biz
        wx.config({
          appId: res.data.appId, //APPID
          timestamp: res.data.timestamp, //上面main方法中拿到的时间戳timestamp
          nonceStr: res.data.nonceStr, //上面main方法中拿到的随机数nonceStr
          signature: res.data.signature, //上面main方法中拿到的签名signature
          //需要调用的方法接口
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'openLocation'
          ]
        })
        wx.ready(() => {
          document.addEventListener("WeixinJSBridgeReady", function () {
            document.querySelector("#music").play()
          }, false);
          this.$refs.musicPlay.play()
          //需在用户可能点击分享按钮前就先调用
          let titles = this.userinfo.nickname + ' 邀请您' + this.activityData.shareTitle
          let sharePic = this.imageUrl + this.activityData.sharePic
          let desc = this.activityData.shareDesc
          let url = this.weixinUrl + 'MerUnionActivity?activityId=' + this.urlParam.activityId + '&merId=' + this.urlParam.merId +
            '&storeId=' + this.urlParam.storeId + '&price=' + this.urlParam.price + '&spreadOpenid=' + this.userinfo.openid
          wx.updateAppMessageShareData({
            title: titles, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic, // 分享图标
            success: () => {
            }
          })
          wx.updateTimelineShareData({
            title: titles, // 分享标题
            link: url, //(window.location.href.split('?'))[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePic, // 分享图标
            success: () => {
              this.saveDiamonds()
              setTimeout(() => {   //设置延迟执行
                this.getUserRed()
              }, 2000)
            }
          })
        })
        wx.error(res => {
          location.reload()
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      })
    },
    //获取用户获取的红包
    getUserRed() {
      if (!this.$util.isArrOrNull(this.user)) {
        this.$api.post({
          url: '/merchant/api/activity/spread-list/find/un-give-red-paper/list',
          data: {
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            activityType: 0
          },
          login: false
        }).then(res => {
          if (!this.$util.isArrOrNull(res.data)) {
            this.redEnvelope = res.data
          }
        })
      }
    },
    //获取网站的信息
    findSiteUrl() {
      this.$api.post({
        url: '/system/config/find/site/url',
        login: false
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.wechatUrl = res.data.wxSiteUrl
          this.wxappUrl = res.data.wxappUrl
        }
      })
    },
    //异步执行
    imageUrlToBase64(imageUrl) {
      //一定要设置为let，不然图片不显示
      let image = new Image()
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = this.imageUrl + imageUrl
      //image.onload为异步加载
      image.onload = () => {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let quality = 0.8
        //这里的dataurl就是base64类型
        let dataURL = canvas.toDataURL('image/jpeg', quality)//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        this.sharePic = dataURL
      }
    },
    //回到顶部
    goTop() {
      let scrollToTop = window.setInterval(function () {
        let pos = window.pageYOffset
        if (pos > 0) {
          window.scrollTo(0, pos - 20) // how far to scroll on each step
        } else {
          window.clearInterval(scrollToTop)
        }
      }, 16)
    },
    checkPhone: function (telnumber) {
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      if (!myreg.test(telnumber)) {
        alert('请输入正确手机号')
        return false
      } else {
        return true
      }
    },
    //用户领取红包
    getRedEnvelope(id, totolMoney) {
      if (this.user.uid != null) {
        this.$router.push({
          path: '/MerTokerGetredEnvelope',
          query: {
            id: id,
            totolMoney: totolMoney,
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            activityType: 1,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            uid: this.user.uid
          }
        })
      } else {
        this.TCyzm = true
      }
    },
    //生成海报
    draw() {
      this.showPoster = true
      if (this.posterImg == '') {
        const opts = {
          useCORS: true
        }
        this.$nextTick(() => {
          let url = window.location.href.split('?')[0] + '?activityId=' + this.urlParam.activityId
            + '&merId=' + this.urlParam.merId + '&storeId=' + this.urlParam.storeId + '&price=' + this.urlParam.price
            + '&spreadOpenid=' + this.userinfo.openid
          let canvas1 = qrcanvas({
            data: decodeURIComponent(url), //分享链接（根据需求来）
            size: window.screen.availWidth * 0.2 //二维码大小
          })
          document.getElementById('qrcode').innerHTML = ''
          document.getElementById('qrcode').appendChild(canvas1)
          window.pageYoffset = 0
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          html2canvas(this.$refs.box, opts).then(canvas => {
            this.posterImg = canvas.toDataURL('image/png')
          })
        })
      }
    },
    //关闭遮罩窗口
    closePoster: function () {
      this.showPoster = false
      this.posterImg = ''
    },
    //关闭遮罩窗口
    closePdUidMask: function () {
      this.pdUid = false
    },
    closeMask() {  //隐藏 表单
      if (this.activityTime != 3) {
        this.isMask = false
        this.isEnd = false
      }
    },
    //暂停或播放音乐
    playMusic() {
      let state = this.$refs.musicInfo.style.animationPlayState
      if (state === 'paused') {
        this.$refs.musicInfo.style.animationPlayState = 'running'
        this.$refs.musicPlay.play()
      } else {
        this.$refs.musicInfo.style.animationPlayState = 'paused'
        this.$refs.musicPlay.pause()
      }
    },
    //跳转到店铺详情
    openStoreDetail(item) {
      this.$router.push({
        path: '/MerUnionStoreDetail',
        query: {
          storeInfo: JSON.stringify(item)
        }
      })
    },
    //打开购买订单界面
    getUserOrder() {
      if (!this.$util.isArrOrNull(this.user)) {
        this.$api.post({
          url: '/merchant/api/merchant/merchant-union-order/find',
          data: {
            activityId: this.urlParam.activityId,
            uid: this.user.uid
          },
          login: false
        }).then(res => {
          if (!this.$util.isArrOrNull(res.data)) {
            this.order = res.data
            this.showOrder = true
          }
        })
      }
    },
    //购买界面显示隐藏
    buy() {
      if (this.activityTime == 1 || this.activityTime == 2) {
        this.isEnd = true
        this.isMask = true
      } else {
        if (this.activityData.limitNumber > this.orderNum) {
          this.showBuy = true
        } else {
          alert('活动已超过限制人数')
          return
        }
      }
    },
    //查看订单
    openOrder() {
      if (!this.$util.isArrOrNull(this.order)) {
        this.$router.push({
          path: '/MerUnionOrderList',
          query: {
            activityId: this.order.activityId,
            uid: this.order.uid
          }
        })
      }
    },
    //关闭购买界面
    closeBuy: function () {
      this.showBuy = false
    },
    //跳转到确认订单界面
    saveOrder() {
      if (this.isOperate) {
        if (this.formObj.truename == null || this.formObj.truename.length < 2) {
          alert('姓名必须大于2个字！')
          return
        }
        let reg = /^1\d{10}$/
        let myreg = /^0\d{2,3}-?\d{7,8}$/
        if (!reg.test(this.formObj.phone) && !myreg.test(this.formObj.phone)) {
          alert('请填写的正确的手机号码格式')
          return
        }
        this.isOperate = false
        this.formObj.openid = this.userinfo.openid
        this.formObj.nickname = this.userinfo.nickname
        this.formObj.fansid = this.user.id
        this.formObj.avatar = this.userinfo.headimgurl
        this.formObj.sex = this.userinfo.sex
        this.$api.post({
          url: '/merchant/api/merchant/merchant-union-order/save',
          data: this.formObj,
          login: false
        }).then(res => {
          this.$router.push({
            path: '/MerUnionConfirmeOrder',
            query: {
              orderInfo: JSON.stringify(res.data),
              actName: this.activityData.name
            }
          })
        }).catch(err => {
          this.isOperate = true
        })
      }
    },
    //跳转到提现界面
    openWithdraw: function () {
      if (this.user.uid == null) {
        this.pdUid = true
      } else {
        this.$router.push({
          path: '/MerUnionCapitalDetail',
          query: {
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            uid: this.user.uid
          }
        })
      }
    },
    //处理红包
    process(redPack) {
      this.redPackList = redPack //红包数组
      this.isAllListDh = redPack.length >= 4 ? true : false //红包数量大于4，红包列表才会有动画
    },
    showDateTime() {
      let date = new Date()
      if (!this.$util.isArrOrNull(this.activityData.startDate) && !this.$util.isArrOrNull(this.activityData.endDate)) {
        let timeNew = this.activityData.startDate - date.getTime()
        let timeOld = this.activityData.endDate - date.getTime()
        if (timeOld < 0) {
          window.clearInterval(this.timeId)  //移除定时器
          this.activityTime = 1 //活动已经截止
          clearInterval(this.downTimeId)
        } else if (timeNew > 0) {//活动未开始
          window.clearInterval(this.timeId)  //移除定时器
          this.activityTime = 2
          //添加一个定时器（5分钟的）
          if (timeNew <= 300000) {
            this.cutDownTime = parseInt(timeNew / 1000) + 1
            this.cutDownTimeFun()
          }
        } else {
          clearInterval(this.downTimeId)
          this.activityTime = 0
          let e_daySold = timeOld / 86400000
          let daySold = Math.floor(e_daySold)
          let e_hrSold = (e_daySold - daySold) * 24
          let hrSold = Math.floor(e_hrSold)
          let e_minSold = (e_hrSold - hrSold) * 60
          let minSold = Math.floor((e_hrSold - hrSold) * 60)
          let seconds = Math.floor((e_minSold - minSold) * 60)
          if (daySold < 10) {
            this.day = '0' + daySold
          } else {
            this.day = daySold
          }
          if (hrSold < 10) {
            this.hour = '0' + hrSold
          } else {
            this.hour = hrSold
          }
          if (minSold < 10) {
            this.minute = '0' + minSold
          } else {
            this.minute = minSold
          }
          if (seconds < 10) {
            this.second = '0' + seconds
          } else {
            this.second = seconds
          }
        }
      }
    },
    //获取倒计时时间
    cutDownTimeFun: function () {
      let cutDownTime = this.cutDownTime
      cutDownTime--
      this.cutDownTime = cutDownTime
      if (cutDownTime == 0) {
        this.clearTime()
        this.activityTime = 0
        this.timeId = setInterval(this.showDateTime, 1000) //执行的定时器 ;
      }
    },
    cell(phone) {
      window.location.href = 'tel:' + phone
    },
    goMap(item) {
      wx.openLocation({
        type: 'gcj02',
        latitude: Number(item.lat), // 纬度，浮点数，范围为90 ~ -90
        longitude: Number(item.lng), // 经度，浮点数，范围为180 ~ -180。
        name: item.name, // 位置名
        address: item.address, // 地址详情说明
        scale: 14, // 地图缩放级别,整型值,范围从1~28。默认为最大
      })
    },
    toUserinfo() {
      if (this.userinfo.openid == null) {
        this.Wechat()
      }
    },
    //获取钻石
    getDiamondsData() {
      if (!this.$util.isArrOrNull(this.user)) {
        this.$api.post({
          url: '/merchant/api/activity/merchant-extend-diamonds/find',
          data: {
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            fansid: this.user.id,
            activityType: 1
          },
          login: false
        }).then(res => {
          if (res.data != null) {
            this.diamonds = res.data
            this.setDiamonds(this.diamonds.lightDiamondsNum)
          }
        })
      }
    },
    //设置钻石
    addDiamonds() {
      let imgs = []
      for (let i = 0; i < this.activityData.diamondsNum; i++) {
        imgs[i] = require('../../resource/img/zuanshi.png')
      }
      this.diamondsImg = imgs
    },
    setDiamonds: function (num) {
      for (let i = 0; i < num; i++) {
        this.diamondsImg[i] = require('../../resource/img/gold.png')
      }
    },
    //获取钻石
    saveDiamonds() {
      if (this.activityData.isOpenFriends == 1 && this.user != null) {
        this.$api.post({
          url: '/merchant/api/activity/merchant-extend-diamonds/union/save',
          data: {
            merId: this.urlParam.merId,
            activityId: this.urlParam.activityId,
            storeId: this.urlParam.storeId,
            fansid: this.user.id,
            activityType: 1
          },
          login: false
        }).then(res => {
          if (res.data != null) {
            this.diamonds = res.data
          }
        })
      }
    },
    //关闭绑定手机号界面
    closeBindPhone() {
      this.TCyzm = false
    },
    //绑定手机号
    bindPhone() {
      if (this.checkPhone(this.$refs.phone.value)) {
        this.$api.post({
          url: '/merchant/api/activity/merchant-market-extend/bind/phone/nocode',
          data: {
            phone: this.$refs.phone.value,
            merId: this.urlParam.merId,
            openid: this.openid,
            fansid: this.user.id,
            storeId: this.urlParam.storeId,
            sourceType: this.formObj.sourceType
          },
          login: false
        }).then(res => {
          location.reload()
        }).catch(err => {
          alert('绑定失败')
        })
      }
    },
  }
}
</script>

<style scoped>
.union-item-div {
  width: 100%;
  height: 100%;
  margin-top: 50px;
  font-size: 15px;
}

.union-item-div .union-item {
  width: 100%;
  min-height: 2007px;
  background-size: cover;
  padding-top: 35px;
}

.union-item-div .union-item .content-top-div {
  width: 100%;
  height: auto;
}

.content-top-div > img {
  width: 100%;
}

.union-item-div .title-div {
  width: 100%;
  height: 60px;
  color: #fff;
  text-align: center;
  font-weight: 800;
  font-size: 20px;
  line-height: 35px;
  margin-top: 20px;
}

.union-item-div .tragedy {
  height: 230px;
  background-color: #fff;
  border-radius: 10px;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 15px;
  overflow: hidden;
}

.union-item-div .tragedy .userinfo {
  height: 75px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #000;
}

.union-item-div .tragedy .userinfo .avatar-img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 20px;
}

.union-item-div .tragedy .userinfo .info {
  display: flex;
  flex-direction: column;
}

.union-item-div .tragedy .userinfo .info .info-top {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.union-item-div .tragedy .userinfo .info .info-top .name {
  font-size: 20px;
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.union-item-div .tragedy .userinfo .info .info-top .diamond {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.union-item-div .tragedy .userinfo .info .info-top .diamond > img {
  width: 37px;
  height: 33px;
}

.union-item-div .tragedy .userinfo .info .text {
  font-size: 12px;
  color: #858585;
}

.union-item-div .tragedy .morals {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.union-item-div .tragedy .morals .morals-value-1 {
  margin: 0 2px;
  font-size: 20px;
  color: #BF0F40;
}

.union-item-div .tragedy .morals .morals-value-2 {
  margin: 0 2px;
  font-size: 20px;
  color: #3CD3A0;
}

.union-item-div .tragedy .user-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  padding: 0 10px;
}

.union-item-div .tragedy .user-list > img {
  width: 40px;
  height: 40px;
  margin: 0 10px;
  border-radius: 20px;
}

.union-item-div .progress {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 120px;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
}

.union-item-div .progress .prs-text {
  font-weight: 800;
}

.union-item-div .progress .prs-text > span {
  background-color: #EC275E;
  padding: 0 8px;
  text-align: center;
  border-radius: 3px;
  color: #fff;
  font-weight: 800;
  margin: 0 3px;
}

.union-item-div .progress .schedule-div {
  width: 100%;
}

.union-item-div .progress .schedule-div .container {
  width: 80%;
  border: 1px solid #ED6942;
  margin-left: 10%;
  border-radius: 5px;
}

.union-item-div .progress .schedule-div .container .skills {
  text-align: right;
  padding-right: 1px;
  height: 30px;
  line-height: 30px;
  color: white;
  border-radius: 5px;
}

.union-item-div .progress .schedule-div .container .skills.html {
  background-color: #ed6942;
}

.union-item-div .progress .bottom-text {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  font-weight: 800;
}

.union-item-div .progress .bottom-text .text-color {
  color: #ED6942;
}

.union-item-div .union-item .content-bottom-div {
  width: 100%;
  height: auto;
}

.content-bottom-div > img {
  width: 100%;
}

.union-item-div .union-item .fixed-menu {
  position: fixed;
  right: 10px;
}

.union-item-div .union-item .fixed-menu.top-menu {
  top: 0px;
}

.union-item-div .union-item .fixed-menu.top-menu .music-img {
  width: 36px;
  height: 36px;
  animation: rotate 2s linear infinite;
}

.union-item-div .union-item .fixed-menu.bottom-menu {
  bottom: 100px;
}

.union-item-div .union-item .fixed-menu > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-color: #000;
  margin-top: 10px;
  border-radius: 30px;
}


.union-item-div .union-item .fixed-menu > div > img {
  width: 36px;
  height: 36px;
}

.union-item-div .union-item .fixed-bottom-menu {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  bottom: 0px;
}

.union-item-div .union-item .fixed-bottom-menu .menu-div {
  flex: 1;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
}

.union-item-div .union-item .fixed-bottom-menu .menu-div.share-menu {
  background-color: #fff;
}

.union-item-div .union-item .fixed-bottom-menu .menu-div.buy-menu {
  background-color: #d00000;
  color: #fff;
}

.union-item-div .union-item .red-envelope-div {
  padding: 2px;
  max-height: 450px;
  background-color: #fff;
  border-radius: 10px;
  margin: 15px 5% 0 5%;
}

.union-item-div .union-item .red-envelope-div .content {
  max-height: 450px;
  border-radius: 20px;
  overflow-y: auto;
}

.union-item-div .union-item .red-envelope-div .content .red-envelope-list {
  margin: 0 2.5%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.union-item-div .union-item .red-envelope-div .content .red-envelope-list .span-div {
  height: 100%;
  font-size: 14px;
  line-height: 50px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
}

.union-item-div .union-item .red-envelope-div .content .red-envelope-list .span-div > span {
  color: #ED6942;
}

.union-item-div .union-item .red-envelope-div .content .red-envelope-list .get-btn {
  height: 30px;
  color: #fff;
  line-height: 30px;
  background-color: #ec5254;
  border-radius: 5px;
  text-align: center;
  padding: 0 15px;
}

.union-item-div .union-item .order-div {
  display: flex;
  flex-wrap: wrap;
  max-height: 450px;
  margin: 15px 5% 0 5%;
  background-color: #fff;
  border-radius: 10px;
  overflow-y: auto;
  padding: 10px;
}

.union-item-div .union-item .order-div .order-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 9px;
  width: 70px;
}

.union-item-div .union-item .order-div .order-info > img {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}

.union-item-div .union-item .order-div .order-info > span {
  max-width: 70px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.union-item-div .union-item .store-list-div {
  height: auto;
  margin: 15px 5% 0 5%;
  padding: 0 20px 20px 20px;
  background-color: #fff;
  border-radius: 10px;
}

.union-item-div .union-item .store-list-div .store-item {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}

.union-item-div .union-item .store-list-div .store-item .store-name {
  font-size: 18px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.union-item-div .union-item .store-list-div .store-item .store-address {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
}

.union-item-div .union-item .store-list-div .store-item .store-address > img {
  width: 16px;
  height: 21px;
  margin-right: 5px;
}

.union-item-div .union-item .store-list-div .store-item .store-address > span {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.union-item-div .union-item .store-list-div .store-item .store-bottom-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  line-height: 30px;
}

.union-item-div .union-item .store-list-div .store-item .store-bottom-info .store-phone {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.union-item-div .union-item .store-list-div .store-item .store-bottom-info .store-phone > img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.union-item-div .union-item .store-list-div .store-item .store-bottom-info .navigation {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 20px;
  background-color: #ffd705;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
}

.union-item-div .union-item .store-list-div .store-item .store-bottom-info .navigation > img {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}

.union-item-div .union-item .store-list-div .store-item .store-img {
  width: 100%;
  height: auto;
  margin-top: 10px;
}

.union-item-div .union-item .store-list-div .store-item .store-bottom-text {
  height: 40px;
  line-height: 40px;
  color: #c48533;
  text-align: center;
  border-bottom: 3px solid #f09a2a;
  margin-top: 5px;
}

.union-item-div .union-item .store-list-div .rule-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.union-item-div .union-item .store-list-div .rule-div .title-text {
  font-size: 20px;
  font-weight: 800;
}

.union-item-div .union-item .store-list-div .rule-div .textarea {
  white-space: pre-line;
}

.union-item-div .union-item .ranking-div {
  max-height: 350px;
  margin: 15px 5% 0 5%;
  padding: 0 20px;
  background-color: #fff;
  border-radius: 10px;
}

.union-item-div .union-item .ranking-div .ranking-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.union-item-div .union-item .ranking-div .ranking-item .index-span {
  flex: 0.3;
}

.union-item-div .union-item .ranking-div .ranking-item .user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-right: 20px;
}

.union-item-div .union-item .ranking-div .ranking-item .user-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.union-item-div .union-item .ranking-div .ranking-item .user-info .name {
  max-width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.union-item-div .union-item .ranking-div .ranking-item .award-info {
  display: flex;
  flex-direction: column;
}

.union-item-div .union-item .bottom-code-info {
  display: flex;
  flex-direction: column;
  height: 500px;
  background-image: url("../../resource/img/j7.png");
  margin: 15px 5% 0 5%;
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
}

.union-item-div .union-item .bottom-code-info .title {
  padding-top: 30px;
  color: #f9ffc7;
  font-size: 30px;
  font-weight: 900;
}

.union-item-div .union-item .bottom-code-info .title-text {
  color: #f9ffc7;
  font-size: 20px;
  margin-top: 10px;
  font-weight: 600;
}

.union-item-div .union-item .bottom-code-info .code-img-div {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}

.union-item-div .union-item .bottom-code-info .code-img-div .code-img-border {
  width: 210px;
  height: 210px;
}

.union-item-div .union-item .bottom-code-info .code-img-div .code-img {
  width: 170px;
  height: 170px;
  position: absolute;
}

.union-item-div .union-item .bottom-code-info .bottom-code-text {
  color: #f9ffc7;
  font-size: 20px;
  margin-top: 40px;
  font-weight: 600;
}

.union-item-div .union-item .bottom-code-info .bottom-code-text-two {
  color: #f9ffc7;
  font-weight: 600;
  margin-top: 10px;
  letter-spacing: 5px;
}

.mask {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
}

.mask.buy {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.buy-div {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, rgba(214, 75, 44, 1) 0%, rgba(235, 116, 66, 1) 100%);
  width: 80%;
  border-radius: 0.1rem;
  padding: 10px;
}

.buy-div .buy-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
}

.buy-div .buy-item .title {
  color: rgb(238, 210, 204);
  flex: 0.3;
}

.buy-div .buy-item input {
  flex: 1;
  height: 35px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
  border: none;
  outline: none;
  padding: 0 10px;
}

.buy-div .buy-item textarea {
  flex: 1;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
  border: none;
  outline: none;
  padding: 5px 10px;
}

.buy-div .buy-btn {
  margin: 5% 0;
  width: 60%;
  height: 35px;
  line-height: 35px;
  border: none;
  outline: none;
  background: linear-gradient(180deg, rgba(242, 235, 159, 1) 0%, rgba(210, 143, 42, 1) 100%);
  box-shadow: 0 0.026667rem 0.133333rem 0 rgba(199, 88, 43, 0.5);
  border-radius: 0.6rem;
  text-align: center;
  color: #d65538;
  border: 0.013333rem solid rgba(222, 156, 159, 1);
}

.mask.poster {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.poster-box {
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 75%;
  height: auto;
  position: absolute;
  padding: 5px;
  z-index: 10;
  top: 20px;
  margin-top: 7%;
}

.poster-box .top-img {
  width: 100%;
  height: auto;
}

.poster-box .user {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}

.poster-box .user .logo-img {
  width: 15%;
  border-radius: 50%;
  margin-right: 10px;
}

.poster-box .user .span-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.poster-box .user .span-info .user-name {
  color: #ed6942;
  font-size: 15px;
}

.poster-box .user .span-info .text-span {
  color: peru;
  font-size: 13px;
  margin-top: 5px;
}

.poster-box .share-title {
  font-size: 16px;
  font-weight: 800;
  margin-top: 5px;
}

.poster-box .bottom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0;
  padding: 0 25px 0 30px;
}

.poster-box .bottom-div .discern-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70px;
}

.poster-box .bottom-div .discern-div .discern-img {
  width: 50px;
  height: 50px;
}


.poster-box .bottom-div .discern-div .span-text {
  color: #ed6942;
  font-size: 14px;
  font-weight: 800;
}

.posterImg {
  flex-direction: column;
  display: flex;
  z-index: 10;
  align-content: center;
  align-items: center;
  width: 70%;
  height: auto;
  position: absolute;
  top: 0px;
}

.posterImg {
  position: absolute;
  z-index: 7;
  top: 20px;
  width: 75%;
}

.posterImg .title-hint {
  color: white;
  margin-bottom: 3%;
  font-size: 15px;
  font-weight: 800;
}

.posterImg > img {
  width: 100%;
}

.form-content {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.titleInfo {
  width: 90%;
  height: 25%;
  display: none;
  position: fixed;
  top: 10%;
  z-index: 7;
  left: 5%;
  background-color: #ffffff;
}

.titleInfo .title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30%;
  background: rgba(248, 248, 248, 1);
}

.close-img {
  width: 30px;
  height: 30px;
  margin-top: 15px;
}

.Ewm_page {
  background: rgba(0, 0, 0, 1.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
}

.imgewm {
  width: 30vh;
  height: 30vh;
  line-height: 30vh;
  background-color: white;
  margin-top: 60%;
  display: block;
  text-align: center;
}

.checktel_telephonenumber > input,
.code_txt > input {
  background-color: #e7e7e7;
}

.r_list > div {
  overflow: hidden;
}

.spantxt > span {
  color: #fff100;
}

.getmoney > span {
  color: #d00000;
}

.y_img > img {
  width: 100%;
}

.mirror > img {
  width: 80%;
  margin-left: 10%;
  margin-top: -10%;
}

.reflect_m > img {
  width: 100%;
}

.creation > img {
  width: 80%;
  margin-left: 10%;
  float: left;
}

.tragedies2 > div {
  width: 100%;
  height: 210px;
  float: left;
  margin-top: 85px;
}

.readers > div {
  color: #fff;
  text-align: center;
  font-size: 25px;
  margin-top: 100px;
}

.zuanshi > div {
  width: 100%;
  height: 100px;
}

.zuanshi > div > img {
  width: 45px;
  height: 45px;
  float: left;
  margin-left: 20px;
  margin-top: 5px;
}

@keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -542.5px, 0);
    transform: translate3d(0, -542.5px, 0);
  }
}

.ai3_l > img {
  width: 100%;
  height: 340px;
}

.aire_rt > img,
.aire_rb > img {
  width: 100%;
  height: 168px;
}

.ai4_l > img {
  width: 100%;
  height: 100%;
}

.aire4_rt > img {
  width: 100%;
  height: 168px;
}

.aire4_rb_l > img,
.aire4_rb_r > img {
  width: 100%;
  height: 168px;
}

.l_img > img {
  width: 81px;
  margin-top: 12px;
}


@keyframes buyss {
  from {
    top: 0px;
  }
  to {
    top: -2000px;
  }
}

.close > img {
  width: 60px;
}

.yz_page {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.yzdiv {
  width: 75%;
  height: 4.5rem;
  background-color: white;
  display: block;
  text-align: left;
  border-radius: 20px;
}

.yzminput {
  width: 90%;
  height: 18%;
  border-radius: 0.266667rem;
  margin-bottom: 2vw;
  padding-left: 2%;
  margin-left: 4%;
  border: none;
  background: rgba(231, 231, 231, 1);
  outline: none;
}

.yzminput::-webkit-input-placeholder {
  /* 字体大小直接写样式即可 */
  font-size: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerUnionActivity.vue